export default "__VITE_ASSET__B2Fc1Xaz__"